import { Colors, Modal, DialogContainer, ModalTitleContainer, ModalTitle, Button, ModelSubHeading, ModalFooter } from "@factorearth/component-library";
import React, { useState } from "react";
import { FiX } from "react-icons/fi";

export function useDownloadImagesModal(): [React.FC<{ color: Colors }>, () => Promise<boolean | null>] {
	const [open, setOpen] = useState(false);
	const [resolver, setResolver] = useState<((value: boolean | null) => void) | undefined>();

	function showModal(): Promise<boolean | null> {
		setOpen(true);
		return new Promise((resolve) => {
			setResolver(() => resolve);
		});
	}

	function DownloadImagesModal({ color }: { color: Colors }) {
		if (!open) return null;

		function submit(savePhotos: boolean | null): void {
			setOpen(false);
			resolver?.(savePhotos);
		}

		return (
			<Modal open={open} colorPalette={color} setOpen={setOpen}>
				<DialogContainer>
					<ModalTitleContainer>
						<ModalTitle>Download Images</ModalTitle>
						<FiX onClick={() => submit(null)} size={24} />
					</ModalTitleContainer>
					<ModelSubHeading>
						Do you want to save photos from these forms to your device for offline use ? This will require more storage space.This is not required
						for the app to function.
					</ModelSubHeading>
					<ModalFooter>
						<Button colorPalette={color} variant="filled" label="Yes" onClick={() => submit(true)} />
						<Button colorPalette={color} variant="filled" label="No" onClick={() => submit(false)} />
						<Button colorPalette={color} variant="destructive" label="Cancel" onClick={() => submit(null)} />
					</ModalFooter>
				</DialogContainer>
			</Modal>
		);
	}

	return [DownloadImagesModal, showModal];
}
